import React, { useState } from 'react';
import { Button, Card, message, Space, Typography } from 'antd';
import { updateSettingsTable, testSettings } from '../services/updateSettingsTable';

const { Title, Text } = Typography;

const UpdateSettingsTable = () => {
  const [loading, setLoading] = useState(false);
  const [testing, setTesting] = useState(false);

  const handleUpdateTable = async () => {
    try {
      setLoading(true);
      const success = await updateSettingsTable();
      if (success) {
        message.success('Settings table updated successfully!');
      } else {
        message.error('Failed to update settings table');
      }
    } catch (error) {
      console.error('Error updating table:', error);
      message.error('Error updating settings table: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleTestSettings = async () => {
    try {
      setTesting(true);
      const success = await testSettings();
      if (success) {
        message.success('Settings test completed! Check console for details.');
      } else {
        message.error('Settings test failed');
      }
    } catch (error) {
      console.error('Error testing settings:', error);
      message.error('Error testing settings: ' + error.message);
    } finally {
      setTesting(false);
    }
  };

  return (
    <div style={{ padding: '24px' }}>
      <Card style={{ maxWidth: '600px', margin: '0 auto' }}>
        <Title level={3}>Update Settings Table</Title>
        <Text>
          This will add the missing columns to your existing settings table and create default settings.
        </Text>
        
        <div style={{ marginTop: '24px' }}>
          <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <Button 
              type="primary" 
              size="large" 
              loading={loading}
              onClick={handleUpdateTable}
              block
            >
              Update Settings Table
            </Button>
            
            <Button 
              type="default" 
              size="large" 
              loading={testing}
              onClick={handleTestSettings}
              block
            >
              Test Settings
            </Button>
          </Space>
        </div>
        
        <div style={{ marginTop: '24px', padding: '16px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
          <Text strong>Instructions:</Text>
          <ul style={{ marginTop: '8px', marginBottom: '0' }}>
            <li>Click "Update Settings Table" to add missing columns and create default settings</li>
            <li>Click "Test Settings" to verify the settings are working</li>
            <li>Check the browser console for detailed logs</li>
            <li>After updating, you can use the Site Settings page normally</li>
          </ul>
        </div>
      </Card>
    </div>
  );
};

export default UpdateSettingsTable;
